/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

  // src/js/soc.js
  (function() {
    "use strict";
    if (window.__socLoaded) return;
    window.__socLoaded = true;
    var root = document.documentElement;
    root.classList.add("soc-js", "soc-serif");
    if (!matchMedia("(prefers-reduced-motion: reduce)").matches && !/[?&]static=1/.test(location.search)) {
      root.classList.add("soc-motion");
    }
    function once(el, key) {
      key = "socInit" + key;
      if (el.dataset[key]) return false;
      el.dataset[key] = "1";
      return true;
    }
    __name(once, "once");
    function init(scope) {
      scope = scope || document;
      var motion = root.classList.contains("soc-motion");
      if (motion && "IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function(entries) {
            entries.forEach(function(e) {
              if (e.isIntersecting) {
                e.target.classList.add("in");
                io.unobserve(e.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: "0px 0px -15% 0px" }
        );
        scope.querySelectorAll("[data-reveal], .scribble-wrap").forEach(function(el) {
          if (!once(el, "Reveal")) return;
          if (el.closest(".sc-hero") && el.classList.contains("scribble-wrap")) return;
          if (el.closest(".sc-study") && el.classList.contains("scribble-wrap")) return;
          io.observe(el);
        });
      } else {
        scope.querySelectorAll(".scribble-wrap").forEach(function(el) {
          el.classList.add("in");
        });
      }
      scope.querySelectorAll(".sc-hero__num").forEach(function(num) {
        if (!once(num, "Count")) return;
        var heroScribble = num.closest(".sc-hero").querySelector(".scribble-wrap");
        var target = parseInt((num.getAttribute("data-count") || num.textContent).replace(/\D/g, ""), 10) || 15120;
        if (!motion) {
          if (heroScribble) heroScribble.classList.add("in");
          return;
        }
        var DUR = 3e3, t0 = null;
        num.textContent = "0";
        function tick(now) {
          if (t0 === null) t0 = now;
          var k = Math.min(1, (now - t0) / DUR);
          var eased = 1 - Math.pow(1 - k, 3);
          num.textContent = Math.round(eased * target).toLocaleString("en-IE");
          if (k < 1) {
            requestAnimationFrame(tick);
          } else {
            num.textContent = target.toLocaleString("en-IE");
            if (heroScribble) heroScribble.classList.add("in");
          }
        }
        __name(tick, "tick");
        requestAnimationFrame(tick);
      });
      scope.querySelectorAll(".scribble path").forEach(function(p) {
        try {
          p.style.setProperty("--len", p.getTotalLength().toFixed(1));
        } catch (e) {
        }
      });
      function setupTrack() {
        if (!motion || !window.gsap || !window.ScrollTrigger) return;
        var track = scope.querySelector ? scope.querySelector(".sc-track") : null;
        if (!track && scope !== document) track = null;
        track = track || document.querySelector(".sc-track");
        if (!track || !once(track, "Pin")) return;
        gsap.registerPlugin(ScrollTrigger);
        var pin = track.querySelector(".sc-track__pin");
        var rail = track.querySelector(".sc-track__rail");
        if (!rail) return;
        root.classList.add("soc-can-pin");
        var headH2 = track.querySelector(".sc-track__head .t-display-section");
        function headTextRect() {
          var r = document.createRange();
          r.selectNodeContents(headH2);
          return r.getBoundingClientRect();
        }
        __name(headTextRect, "headTextRect");
        function alignStart() {
          rail.style.paddingLeft = Math.max(16, headTextRect().left) + "px";
        }
        __name(alignStart, "alignStart");
        window.addEventListener("resize", alignStart);
        var overflow = /* @__PURE__ */ __name(function() {
          var last = rail.lastElementChild.getBoundingClientRect();
          return Math.max(0, last.right - headTextRect().right);
        }, "overflow");
        if (overflow() < 40) {
          root.classList.remove("soc-can-pin");
          return;
        }
        gsap.to(rail, {
          x: /* @__PURE__ */ __name(function() {
            return -overflow();
          }, "x"),
          ease: "none",
          scrollTrigger: {
            trigger: track,
            pin,
            scrub: true,
            start: "top top",
            end: /* @__PURE__ */ __name(function() {
              return "+=" + overflow();
            }, "end"),
            invalidateOnRefresh: true
          }
        });
      }
      __name(setupTrack, "setupTrack");
      if (document.readyState === "complete") {
        setupTrack();
      } else {
        window.addEventListener("load", setupTrack);
      }
      function makeCarousel(dlg, items) {
        var rail = dlg.querySelector(".sc-caro__rail");
        var nav = dlg.querySelector(".sc-caro__nav");
        var current = 0;
        items.forEach(function(item, i) {
          var it = document.createElement("div");
          it.className = "sc-caro__item";
          if (item.img) {
            var im = document.createElement("img");
            im.src = item.img;
            im.alt = item.alt || "";
            it.appendChild(im);
          }
          var body = document.createElement("div");
          body.className = "sc-caro__body";
          body.innerHTML = item.bodyHTML;
          it.appendChild(body);
          it.addEventListener("click", function() {
            if (i !== current) go(i);
          });
          rail.appendChild(it);
          var dot = document.createElement("button");
          dot.type = "button";
          dot.setAttribute("aria-label", item.title || "Item " + (i + 1));
          dot.addEventListener("click", function() {
            go(i);
          });
          nav.appendChild(dot);
        });
        function layout() {
          var els = rail.children;
          if (!els.length) return;
          var w = els[0].offsetWidth;
          var offset = (window.innerWidth - w) / 2 - current * (w + 32);
          rail.style.transform = "translateX(" + offset + "px)";
          Array.prototype.forEach.call(els, function(el, i) {
            el.classList.toggle("active", i === current);
          });
          Array.prototype.forEach.call(nav.children, function(d, i) {
            d.classList.toggle("on", i === current);
            d.setAttribute("aria-current", i === current ? "true" : "false");
          });
        }
        __name(layout, "layout");
        function go(i) {
          current = Math.max(0, Math.min(items.length - 1, i));
          layout();
        }
        __name(go, "go");
        dlg.querySelector(".sc-caro__close").addEventListener("click", function() {
          dlg.close();
        });
        dlg.addEventListener("click", function(e) {
          if (e.target === dlg) dlg.close();
        });
        var swipeX = null, swipeY = null;
        dlg.addEventListener(
          "touchstart",
          function(e) {
            swipeX = e.touches[0].clientX;
            swipeY = e.touches[0].clientY;
          },
          { passive: true }
        );
        dlg.addEventListener(
          "touchend",
          function(e) {
            if (swipeX === null) return;
            var dx = e.changedTouches[0].clientX - swipeX;
            var dy = e.changedTouches[0].clientY - swipeY;
            swipeX = swipeY = null;
            if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) go(current + (dx < 0 ? 1 : -1));
          },
          { passive: true }
        );
        window.addEventListener("resize", function() {
          if (dlg.open) layout();
        });
        document.addEventListener("keydown", function(e) {
          if (!dlg.open) return;
          if (e.key === "ArrowRight") go(current + 1);
          if (e.key === "ArrowLeft") go(current - 1);
        });
        return /* @__PURE__ */ __name(function openAt(i) {
          current = i;
          dlg.showModal();
          requestAnimationFrame(layout);
        }, "openAt");
      }
      __name(makeCarousel, "makeCarousel");
      scope.querySelectorAll('[data-soc-cardset][data-expand="modal"]').forEach(function(set) {
        if (!once(set, "Caro") || !window.HTMLDialogElement) return;
        var cards = Array.prototype.slice.call(set.querySelectorAll("[data-soc-card]"));
        if (!cards.length) return;
        var items = cards.map(function(card) {
          var img = card.querySelector("img");
          var tpl = card.querySelector("template[data-modal-body]");
          return {
            img: img ? img.src : "",
            alt: img ? img.alt : "",
            title: card.getAttribute("data-card-title") || "",
            bodyHTML: tpl ? tpl.innerHTML : ""
          };
        });
        var dlg = document.createElement("dialog");
        dlg.className = "sc sc-caro";
        dlg.setAttribute("aria-label", set.getAttribute("data-caro-label") || "Details");
        dlg.innerHTML = '<button class="sc-caro__close" aria-label="Close">&#215;</button><div class="sc-caro__rail"></div><div class="sc-caro__nav"></div>';
        document.body.appendChild(dlg);
        var openAt = makeCarousel(dlg, items);
        cards.forEach(function(card, i) {
          card.querySelectorAll("[data-soc-zoom], .sc-card__media, .sc-garment__media, [data-soc-flip]").forEach(function(el) {
            el.addEventListener("click", function() {
              openAt(i);
            });
          });
        });
      });
      scope.querySelectorAll(".sc-phasenav").forEach(function(pnav) {
        if (!once(pnav, "Spy") || !("IntersectionObserver" in window)) return;
        var links = Array.prototype.slice.call(pnav.querySelectorAll("a"));
        var spy = new IntersectionObserver(
          function(entries) {
            entries.forEach(function(e) {
              if (!e.isIntersecting) return;
              links.forEach(function(a) {
                var current = a.getAttribute("href") === "#" + e.target.id;
                a.setAttribute("aria-current", current ? "true" : "false");
                if (current && pnav.scrollWidth > pnav.clientWidth) {
                  var delta = a.getBoundingClientRect().left - pnav.getBoundingClientRect().left;
                  pnav.scrollTo({
                    left: pnav.scrollLeft + delta - (pnav.clientWidth - a.offsetWidth) / 2,
                    behavior: "smooth"
                  });
                }
              });
            });
          },
          { rootMargin: "-30% 0px -60% 0px" }
        );
        var lastTarget = null;
        links.forEach(function(a) {
          var t = document.getElementById(a.getAttribute("href").slice(1));
          if (t) {
            spy.observe(t);
            lastTarget = t;
          }
        });
        var chipsWrapper = pnav.closest(".soc-anchor-chips");
        if (chipsWrapper) {
          var themeHeader = document.querySelector("#pageheader") || document.querySelector(".section-header");
          var setChipsTop = /* @__PURE__ */ __name(function() {
            if (!themeHeader) return;
            var b = themeHeader.getBoundingClientRect().bottom;
            chipsWrapper.style.top = Math.round(Math.max(14, b + 14)) + "px";
          }, "setChipsTop");
          setChipsTop();
          window.addEventListener("resize", setChipsTop);
          var chipsTopTick = false;
          window.addEventListener(
            "scroll",
            function() {
              if (!chipsTopTick) {
                chipsTopTick = true;
                requestAnimationFrame(function() {
                  chipsTopTick = false;
                  setChipsTop();
                });
              }
            },
            { passive: true }
          );
        }
        if (chipsWrapper && lastTarget) {
          var releaseEl = lastTarget.closest(".shopify-section") || lastTarget;
          var chipsTick = false;
          var releaseCheck = /* @__PURE__ */ __name(function() {
            chipsTick = false;
            var done = releaseEl.getBoundingClientRect().bottom < chipsWrapper.getBoundingClientRect().bottom;
            chipsWrapper.classList.toggle("soc-chips-done", done);
          }, "releaseCheck");
          window.addEventListener(
            "scroll",
            function() {
              if (!chipsTick) {
                chipsTick = true;
                requestAnimationFrame(releaseCheck);
              }
            },
            { passive: true }
          );
          releaseCheck();
        }
      });
      scope.querySelectorAll("[data-strip]").forEach(function(strip) {
        if (!once(strip, "Strip")) return;
        var form = strip.querySelector("[data-form]");
        var phone = strip.querySelector("[data-field-phone]");
        var email = strip.querySelector("[data-field-email]");
        var swap = strip.querySelector("[data-swap]");
        var done = strip.querySelector("[data-done]");
        var mode = "wa";
        var arm = strip.querySelector("[data-arm]");
        if (arm)
          arm.addEventListener("click", function() {
            strip.classList.add("armed");
            phone.focus();
          });
        if (swap)
          swap.addEventListener("click", function() {
            mode = mode === "wa" ? "email" : "wa";
            phone.hidden = mode === "email";
            email.hidden = mode === "wa";
            swap.textContent = mode === "wa" ? "Prefer email instead?" : "Prefer WhatsApp instead?";
            (mode === "wa" ? phone : email).focus();
          });
        if (form)
          form.addEventListener("submit", function(e) {
            e.preventDefault();
            var field = mode === "wa" ? phone : email;
            var consent = form.querySelector('input[type="checkbox"]');
            if (!field.value.trim()) {
              field.setCustomValidity(mode === "wa" ? "Enter your mobile number." : "Enter your email address.");
              field.reportValidity();
              field.addEventListener(
                "input",
                function() {
                  field.setCustomValidity("");
                },
                { once: true }
              );
              return;
            }
            if (consent && !consent.checked) {
              consent.reportValidity();
              return;
            }
            strip.classList.add("sent");
            if (done) {
              var msg = mode === "wa" ? strip.getAttribute("data-success-wa") || "Sent. Check WhatsApp in a minute - forward it on." : strip.getAttribute("data-success-email") || "Sent. Check your inbox - forward it on.";
              requestAnimationFrame(function() {
                done.textContent = msg;
              });
            }
          });
      });
      scope.querySelectorAll("[data-passon-form]").forEach(function(form) {
        if (!once(form, "Passon")) return;
        var phone = form.querySelector('input[type="tel"]');
        var email = form.querySelector('input[type="email"]');
        form.addEventListener("submit", function(e) {
          if (form.hasAttribute("data-live")) {
            if (!phone.value.trim() && !email.value.trim()) {
              e.preventDefault();
              email.setCustomValidity("Enter a WhatsApp number or email address.");
              email.reportValidity();
              email.addEventListener(
                "input",
                function() {
                  email.setCustomValidity("");
                },
                { once: true }
              );
            }
            return;
          }
          e.preventDefault();
          if (!phone.value.trim() && !email.value.trim()) {
            email.setCustomValidity("Enter a WhatsApp number or email address.");
            email.reportValidity();
            email.addEventListener(
              "input",
              function() {
                email.setCustomValidity("");
              },
              { once: true }
            );
            return;
          }
          var consent = form.querySelector('input[type="checkbox"]');
          if (consent && !consent.checked) {
            consent.setCustomValidity("Please tick the box so we can send it to you.");
            consent.reportValidity();
            consent.addEventListener(
              "change",
              function() {
                consent.setCustomValidity("");
              },
              { once: true }
            );
            return;
          }
          var success = form.getAttribute("data-success") || "Thanks - you\u2019re on the list.";
          if (phone.value.trim() && !email.value.trim()) success = "Sent. Check your WhatsApp for the parent summary.";
          showSuccess(form, success);
        });
      });
      scope.querySelectorAll("form[data-stub]").forEach(function(form) {
        if (!once(form, "Stub")) return;
        form.addEventListener("submit", function(e) {
          e.preventDefault();
          var email = form.querySelector('input[type="email"]');
          if (email && !email.checkValidity()) {
            email.reportValidity();
            return;
          }
          showSuccess(form, form.getAttribute("data-success") || "Thanks - you\u2019re on the list.");
        });
      });
      function showSuccess(form, text) {
        var note = form.nextElementSibling && form.nextElementSibling.classList.contains("form-success") ? form.nextElementSibling : null;
        if (!note) {
          note = document.createElement("p");
          note.className = "form-success t-body";
          note.setAttribute("role", "status");
          form.insertAdjacentElement("afterend", note);
        }
        note.textContent = text;
        form.querySelectorAll("input, button").forEach(function(el) {
          el.disabled = true;
        });
      }
      __name(showSuccess, "showSuccess");
    }
    __name(init, "init");
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function() {
        init(document);
      });
    } else {
      init(document);
    }
    document.addEventListener("shopify:section:load", function(e) {
      init(e.target);
    });
    document.addEventListener("shopify:section:reorder", function() {
      init(document);
    });
  })();
})();
